import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Pages'
import { mediaPlatformRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Pages'

export const mediaPlatformPagesRoute = createRoute({
  getParentRoute: () => mediaPlatformRoute,
  path: StaticRouteParameter.PAGES,
  loader: () => ({
    crumb: t('entity:publishing.page', { count: 2 }),
  }),
})

export const mediaPlatformPagesLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformPagesRoute,
  id: 'mediaPlatformPagesLayout',
  component: Structure,
})

type MediaPlatformPagesOverviewSearch = {
  query?: string
}

export const mediaPlatformPagesOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformPagesLayoutRoute,
  path: '/',
  component: Overview,
  validateSearch: (search: Record<string, unknown>): MediaPlatformPagesOverviewSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})
